<template>

  <div id="wrapper" class="">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <a class="small-header-action" href="">
            <div class="clip-header">
              <i class="fa fa-arrow-up"></i>
            </div>
          </a>

          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li><router-link :to="{name: 'ManageProfiles'}">Manage Profiles</router-link></li>
              <li class="active">
                <span>Profile</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            Manage Profile
          </h3>
          <small>Edit credit of profile</small>
        </div>
      </div>
    </div>

    <div class="content" v-if="profile">

      <div class="row">
        <div class="col-xs-12">
          <div class="hpanel">
            <div class="panel-heading">
              Profile Settings
            </div>
            <div class="panel-body">
              <profile-settings :profile="profile"></profile-settings>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ProfileSettings from '../../components/profile/ProfileSettings'

export default {
  components: {
    ProfileSettings
  },
  name: 'EditProfile',
  props: [],
  data () {
    return {
      profile: null
    }
  },
  watch: {
  },
  methods: {
    getResources: function () {
      if (this.userId !== null) {
        axios.get('/profile/' + this.profileId)
          .then((response) => {
            this.profile = response.data
          })
          .catch(function (error) {
          })
      }
    },
  },
  mounted () {
  },
  beforeMount () {
    this.profileId = typeof this.$route.params.id !== 'undefined' ? this.$route.params.id : null
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/manageProfiles/EditProfile.vue